module.exports = __webpack_public_path__ + "static/media/teygja_armretta_a.6a5ddef1.png";